import axiosConfig from "./axiosConfig";

export interface ArtifactUploadUrl {
  url: string;
  artifactGuid: string;
}

const getSiteArtifactUploadUrl = async (
  authToken: string,
  siteId: string,
  contentType: string,
  filename: string
): Promise<ArtifactUploadUrl> => {
  const { data } = await axiosConfig.post(
    `/site/${siteId}/artifacts`,
    {
      contentType,
      filename,
    },
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteArtifactUploadUrl;
